const ComputePercentageUtils = (value: number | null): string =>
  value === null ? '' : `${Math.round((1 - value) * 1000) / 10}%`

export default ComputePercentageUtils
